import { useMutation, useQueryClient } from '@tanstack/react-query';
import { expertProfileApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertProfileFormData } from '../types/expert-profile';

export function useUpdateExpertProfile(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: ExpertProfileFormData) =>
      expertProfileApi.updateExpertProfile(id, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.expertProfiles.detail(id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.expertProfiles.lists() });
    },
  });
}
